import React from 'react';
import LocationHelper from '../../helpers/location_helper';
import * as ApplicationHelper from '../../helpers/application_helper';

const QAHiddenElement = ({ showInLowerEnvironments = false, className = '', children, style }) => {
  try {
    const calcClassName =
      !ApplicationHelper.isSelenium() &&
      showInLowerEnvironments &&
      LocationHelper.getEnvByDomain() !== 'prod' &&
      LocationHelper.getEnvByDomain() !== 'qa'
        ? 'qa-shown'
        : 'qa-hidden';

    return (
      <div
        className={`${className ? className : ''} ${calcClassName}`}
        style={{
          padding: '5px',
          zIndex: '-1',
          color: 'black',
          background: 'rgba(0, 98, 190, 0.4)',
          border: 'solid black 1px',
          borderRadius: '10px',
          ...style,
        }}
      >
        {children}
      </div>
    );
  } catch (e) {
    return <div className={'qa-element-error'}></div>;
  }
};

export default QAHiddenElement;
